import Vue from 'vue';
import VueTippy, {TippyComponent} from 'vue-tippy';

Vue.use(VueTippy, {
    placement: 'bottom',
    theme: 'google',
    animation: 'scale',
});

Vue.component('tippy', TippyComponent);
